import axios from "axios";
import { SERVER_URL } from "../../config/env";
import authHeader from "../utils/auth/auth-header";

// ✅ Utility: convert file → base64
const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    if (!file) return reject(new Error("No file provided"));

    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

class ImageService {
  async upload(userId, file) {
    if (!userId) throw new Error("Missing userId");
    if (!file) throw new Error("No image file provided");

    try {
      const base64Image = await fileToBase64(file);

      const response = await axios.post(
        `${SERVER_URL}ksbhub/userupdate/avatar/${userId}`,
        { image: base64Image },
        {
          headers: {
            ...authHeader(),
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Image upload failed:", this._formatError(error));
      throw error;
    }
  }

  async getCurrentAvatar() {
    try {
      const response = await axios.get(`${SERVER_URL}update/currentavatar`, {
        headers: authHeader(),
      });

      return response.data;
    } catch (error) {
      console.error("Fetching avatar failed:", this._formatError(error));
      throw error;
    }
  }

  // ✅ centralized error formatting
  _formatError(error) {
    if (error.response) return error.response.data;
    if (error.request) return "No response from server";
    return error.message;
  }
}

const imageService = new ImageService();
export default imageService;
